/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_GroceryInputs */

const en_homepage_listen_in_grocery = /** @type {(inputs: Homepage_Listen_In_GroceryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grocery Shopping`)
};

const es_homepage_listen_in_grocery = /** @type {(inputs: Homepage_Listen_In_GroceryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haciendo la compra`)
};

/**
* | output |
* | --- |
* | "Grocery Shopping" |
*
* @param {Homepage_Listen_In_GroceryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_grocery = /** @type {((inputs?: Homepage_Listen_In_GroceryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_GroceryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_grocery(inputs)
	return en_homepage_listen_in_grocery(inputs)
});